<template>
  <div name="demo-import-excel">
    <label for="file">Import Excel</label>
    <input type="file" id="file" accept=".xlsx,.xlsb,.xlsm,.xls,.xml,.csv,.txt,.ods,.fods,.uos,.sylk,.dif,.dbf,.prn,.qpw,.123,.wb*,.wq*,.html,.htm" @change="_change" >
    <label for="checkbox">Headers</label>
    <input type="checkbox" id="checkbox" v-model="checked" >
  </div>
</template>

<script>
import X from 'xlsx'
const makeCols = refstr => Array(X.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({name: X.utils.encode_col(i), key: i}))
export default {
  name: 'demo-import-excel',
  data: function () {
    return {
      checked: true
    }
  },
  methods: {
    _change (evt) {
      const files = evt.target.files
      if (files && files[0]) this._file(files[0])
    },
    _file (file) {
      const reader = new window.FileReader()
      reader.onload = (e) => {
        const descriptions = ['รหัสพนักงาน', 'KPI No.', 'รายการ KPI', 'Target/Reference Value', 'หน่วยชี้วัด', 'Weight', 'Target Date', 'มูลค่า', 'รายละเอียดงานที่ทำ1', 'รายละเอียดงานที่ทำ2', 'รายละเอียดงานที่ทำ3', 'รายละเอียดงานที่ทำ4', 'รายละเอียดงานที่ทำ5', 'รายละเอียดงานที่ทำ6', 'รายละเอียดงานที่ทำ7', 'รายละเอียดงานที่ทำ8', 'รายละเอียดงานที่ทำ9', 'รายละเอียดงานที่ทำ10', 'รายละเอียดงานที่ทำ11', 'รายละเอียดงานที่ทำ12', 'รายละเอียดงานที่ทำ13', 'รายละเอียดงานที่ทำ14', 'รายละเอียดงานที่ทำ15', 'รายละเอียดงานที่ทำ16', 'รายละเอียดงานที่ทำ17', 'รายละเอียดงานที่ทำ18', 'รายละเอียดงานที่ทำ19', 'รายละเอียดงานที่ทำ20', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้', 'Ranking', 'ผลงานที่ได้', 'ช่วงมูลค่าตั้งแต่', 'ช่วงมูลค่าถึง', 'คะแนนที่ได้']
        const bstr = e.target.result
        const wb = X.read(bstr, {type: 'binary'})
        const ws = wb.Sheets['Data']
        const data = X.utils.sheet_to_json(ws, {header: this.mapExcelRows(descriptions)})
        this.data = this.checked ? data.shift() : data
        this.cols = makeCols(ws['!ref'])

        // result
        console.info(this.mapExcelHeaders(descriptions))
        console.info(data)
      }
      reader.readAsBinaryString(file)
    },
    mapExcelHeaders (descriptions) {
      let n = 0
      return descriptions.map(function (x) {
        n++
        return {
          key: 'item' + n,
          name: x
        }
      })
    },
    mapExcelRows (descriptions) {
      let n = 0
      return descriptions.map(function (x) {
        n++
        return 'item' + n
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// demoImportExcel.vue?3004bd1c